import React from 'react';
import { observer } from 'mobx-react';
import styled from 'styled-components';
import { media } from 'legacyComponents/styled/styleUtils';
import PropTypes from 'prop-types';

export const SectionHeader = observer(
  ({ tabs, activeTab, handleTabClick, button }) => {
    const tabTitles = [];
    // FIXME - replace with map
    // eslint-disable-next-line
    for (const tab of tabs) {
      tabTitles.push(
        <Title
          active={activeTab === tab[0]}
          onClick={() => handleTabClick(tab[0])}
          key={tab[0]}
        >
          {tab[1]}
          {tab[2] !== false ? (
            <Count active={activeTab === tab[0]}>{` (${tab[2]})`}</Count>
          ) : (
            ''
          )}
        </Title>,
      );
    }
    return (
      <Main>
        {tabTitles}
        {button}
      </Main>
    );
  },
);

const Main = styled.div`
  width: 100%;
  height: 62px;
  margin: 0 -1px 20px;
  border: 1px solid ${props => props.theme.color.wfGrey300};
  background-color: ${props => props.theme.color.wfWhite};
  overflow: hidden;
  ${media.xs`
    height: 54px;
  `};
`;

const Title = styled.h2`
  display: inline-block;
  font-weight: 600;
  font-size: 0.875em;
  padding: 24px 10px 17px;
  margin: 0 40px 0 20px;
  color: ${props =>
    props.active ? props.theme.color.primary : props.theme.color.wfGrey};
  border-bottom: ${props =>
    props.active
      ? `3px solid ${props.theme.color.primary}`
      : `3px solid ${props.theme.color.wfWhite}`};
  transition: color 100ms ease-in-out, border 100ms ease-in-out;
  &:hover {
    cursor: pointer;
    color: ${props => props.theme.color.primary};
  }
  ${media.m`
    margin: 0 20px 0 15px;
  `};
  ${media.xs`
    font-size: 0.8em;
    margin: 0 10px 0 10px;
    padding: 20px 8px 17px;
  `};
`;

const Count = styled.span`
  color: ${props =>
    props.active ? props.theme.color.primary : 'rgba(0, 0, 0, 0.35)'};
`;

SectionHeader.propTypes = {
  tabs: PropTypes.array,
  activeTab: PropTypes.string,
  handleTabClick: PropTypes.func,
};
